import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Tu hijo es adolescente y cada conversación termina en silencio o en grito', 'Ya probaste hablar y no funcionó', 'Querés herramientas concretas, no más teoría', 'Necesitás algo que puedas usar esta noche'];
const noItems = ['Buscás un diagnóstico médico', 'Esperás que tu hijo lo haga solo sin acompañamiento', 'Querés un libro de teoría psicológica'];
export function IsForYou() {
  return <section className="py-12 bg-background border-t border-white/5" aria-label="¿Es para vos?" data-id="element-140">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-141">
        <FadeIn data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-143">
            ¿ESTE KIT ES PARA <span className="text-gold" data-id="element-144">VOS</span>?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-145">
          {/* YES column */}
          <FadeIn delay={0.1} data-id="element-146">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-emerald-500/20 h-full" data-id="element-147">
              <div className="flex items-center gap-3 mb-6" data-id="element-148">
                <span className="text-2xl" data-id="element-149">✅</span>
                <h3 className="text-xl font-bold text-emerald-400" data-id="element-150">
                  Este kit es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-151">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-152">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-153" />
                    <span className="text-gray-200" data-id="element-154">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO column */}
          <FadeIn delay={0.2} data-id="element-155">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-red-500/20 h-full" data-id="element-156">
              <div className="flex items-center gap-3 mb-6" data-id="element-157">
                <span className="text-2xl" data-id="element-158">❌</span>
                <h3 className="text-xl font-bold text-red-400" data-id="element-159">
                  Este kit NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-160">
                {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-161">
                    <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-162" />
                    <span className="text-gray-300" data-id="element-163">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}